/* eslint-disable no-restricted-syntax */
import React from 'react';
import PropTypes from 'prop-types';

export const availableVariants = [
  'primary',
  'danger',
  'secondary',
  'outline-primary',
  'outline-danger',
  'outline-primary-rounded',
  'outline-danger-rounded',
  'tab',
  'text',
  'sentence',
  'underlined-sentence',
  'sentence-options',
  'icon',
  'secondary hover-primary',
  'secondary hover-danger',
  'primary-rounded',
  'danger-rounded',
  'secondary-rounded hover-primary',
  'secondary-rounded hover-danger',
  'secondary-rounded',
  'yellow',
];
const availableSize = ['sm'];
const forbiddenStyle = [
  'color',
  'fontWeight',
  'fontSize',
  'background',
  'backgroundColor',
  'border',
  'borderRadius',
  'display',
  'padding',
  'paddingTop',
  'paddingBottom',
  'paddingLeft',
  'paddingRight',
  'lineHeight',
];

const Button = (props) => {
  const {
    disabled,
    inline,
    square,
    negative,
    className,
    active,
    variant,
    size,
    icon,
    iconPosition,
    fluid,
    style,
    tooltipTitle,
    children,
    isHighlight,
    ...rest
  } = props;

  const classNameArr = ['ajaib-btn', 'btn'];
  if (active) {
    classNameArr.push('active');
  }
  if (variant && availableVariants.includes(variant)) {
    if (variant === 'secondary hover-primary') {
      classNameArr.push('btn-secondary');
      classNameArr.push('hover-primary');
    } else if (variant === 'secondary hover-danger') {
      classNameArr.push('btn-secondary');
      classNameArr.push('hover-danger');
    } else {
      classNameArr.push(`btn-${variant}`);
    }
  }
  if (size && availableSize.includes(size)) {
    classNameArr.push(`btn-${size}`);
  }
  if (fluid) {
    classNameArr.push('fluid');
  }
  if (negative) {
    classNameArr.push('btn-negative');
  }
  if (square) {
    classNameArr.push('btn-square');
  }
  if (inline) {
    classNameArr.push('btn-inline');
  }

  if (style) {
    for (const forbid of forbiddenStyle) {
      if (style[forbid]) delete style[forbid];
    }
  }
  const iconClass = ['icon', `icon-${iconPosition}`];
  if (children) {
    iconClass.push('with-text');
  }

  return (
    <button
      disabled={disabled}
      className={`${className} ${classNameArr.join(' ')}`}
      style={isHighlight ? { ...style, borderRadius: '8px' } : style}
      data-toggle="tooltip"
      data-placement="top"
      title={tooltipTitle}
      type="button"
      {...rest}
    >
      {icon !== null && icon !== '' && iconPosition === 'left' && (
        <img src={icon} className={iconClass.join(' ')} alt="" />
      )}
      {children}
      {icon !== null && icon !== '' && iconPosition === 'right' && (
        <img src={icon} className={iconClass.join(' ')} alt="" />
      )}
    </button>
  );
};

Button.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  fluid: PropTypes.bool,
  icon: PropTypes.string,
  iconPosition: PropTypes.string,
  inline: PropTypes.bool,
  isHighlight: PropTypes.bool,
  negative: PropTypes.bool,
  size: PropTypes.string,
  square: PropTypes.bool,
  style: PropTypes.object,
  tooltipTitle: PropTypes.string,
  variant: PropTypes.string,
};

Button.defaultProps = {
  active: false,
  children: '',
  className: '',
  disabled: false,
  fluid: false,
  icon: null,
  iconPosition: 'left',
  inline: false,
  isHighlight: false,
  negative: false,
  size: null,
  square: false,
  style: null,
  tooltipTitle: '',
  variant: 'primary',
};

export default Button;
